import { render } from "./AppAdsTxtScreen.vue?vue&type=template&id=95b0a0fe"
import script from "./AppAdsTxtScreen.vue?vue&type=script&lang=js"
export * from "./AppAdsTxtScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__